import toTitleCase from "../functions/formatting/toTitleCase";

/**
 * Properly capitalizes a conversation title
 * Capitalizes the first letter of the string and the first letter after each period,
 * question mark, or exclamation mark followed by a space.
 * 
 * @param {string} title - The conversation title to capitalize
 * @param {boolean} useTitleCase - Whether to also apply title case (capitalize each word)
 * @returns {string} - The properly capitalized title
 */
export const capitalizeConversationTitle = (title, useTitleCase = false) => {
  if (!title || typeof title !== 'string') return title;
  
  // Capitalize the first character of the string
  let capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);
  
  // Capitalize the first character after each sentence-ending punctuation
  capitalizedTitle = capitalizedTitle.replace(
    /([.!?]\s+)([a-z])/g, 
    (match, punctuation, letter) => punctuation + letter.toUpperCase()
  );
  
  // Apply title case if requested (capitalize each word appropriately)
  if (useTitleCase) {
    return toTitleCase(capitalizedTitle);
  }
  
  return capitalizedTitle;
}; 